import { render } from "./lotteryResult.vue?vue&type=template&id=4b51578a&scoped=true"
import script from "./lotteryResult.vue?vue&type=script&lang=js"
export * from "./lotteryResult.vue?vue&type=script&lang=js"

import "./lotteryResult.vue?vue&type=style&index=0&id=4b51578a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b51578a"]])

export default __exports__